(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired124"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired124"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("97vXv", function(module, exports) {
//------------------------------------------------------------------------------
//

var $dVE5d = parcelRequire("dVE5d");

var $kbC9w = parcelRequire("kbC9w");
//------------------------------------------------------------------------------
//
var totalAllowedCourses = 4;
//if the programme builder is not on the page then - all done
var programmeBuilder = document.querySelector(".programme-builder");
if (programmeBuilder == null) return;
//
var programmeBuilderCourses = programmeBuilder.querySelectorAll(".programme-builder-course");
var tooManyCoursesWarning = programmeBuilder.querySelector(".too-many-courses-warning");
//------------------------------------------------------------------------------
//
var renderProgrammeBuilderPricing = function() {
    //
    var selectedCourses = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = programmeBuilder.querySelectorAll(".programme-builder-course[data-selected]")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var course = _step.value;
            selectedCourses.push({
                "courseID": course.dataset.courseId,
                "courseName": course.dataset.courseName,
                "normalPrice": parseFloat(course.dataset.normalPrice),
                "programmePrice": parseFloat(course.dataset.programmePrice)
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    //store the user's latest selection into session storage (in-case they leave and come back)
    $kbC9w.set("programme-builder-selection", selectedCourses.reduce(function(acc, item) {
        acc.push(item.courseID);
        return acc;
    }, []));
    //
    var selectedCoursesCount = selectedCourses.length;
    //
    var normalTotal = selectedCourses.reduce(function(acc, value) {
        return acc + value["normalPrice"];
    }, 0);
    var programmeTotal = selectedCourses.reduce(function(acc, value) {
        return acc + value["programmePrice"];
    }, 0);
    var totalSaved = normalTotal - programmeTotal;
    //pad the selected courses so we can see how many "slots" we are allowed
    for(var i = selectedCourses.length; i < totalAllowedCourses; i++)selectedCourses.push({
        "courseName": null
    });
    //hide the warning about too many courses if it's visible
    tooManyCoursesWarning.removeAttribute("data-visible");
    //
    var programmeBuilderSelectionPanel = document.querySelector(".programme-builder-selection");
    programmeBuilderSelectionPanel.innerHTML = $dVE5d("programme-builder-selection-panel", {
        //
        "totalAllowedCourses": totalAllowedCourses,
        //
        "selectedCoursesCount": selectedCoursesCount,
        "selectedCourses": selectedCourses,
        //
        "normalTotal": normalTotal,
        "programmeTotal": programmeTotal,
        "totalSaved": totalSaved
    });
};
//------------------------------------------------------------------------------
//if the user has some previously selected course try to reload it 
if ((programmeBuilderSelection = $kbC9w.get("programme-builder-selection")) !== null) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = programmeBuilderSelection[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var previouslySelectedCourse = _step.value;
            if ((previouslySelectedCourseElement = programmeBuilder.querySelector('.programme-builder-course[data-course-id="'.concat(previouslySelectedCourse, '"]'))) !== null) previouslySelectedCourseElement.setAttribute("data-selected", "data-selected");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
//
renderProgrammeBuilderPricing();
var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
try {
    var _loop = function() {
        var course = _step1.value;
        if (toggleSelectionButton = course.querySelector('a[data-action="toggle-selection"]')) toggleSelectionButton.addEventListener("click", function(event) {
            //
            event.preventDefault();
            //if we are trying to select a new course, check to see if we have enough slots
            if (!course.hasAttribute("data-selected") && programmeBuilder.querySelectorAll(".programme-builder-course[data-selected]").length >= totalAllowedCourses) {
                tooManyCoursesWarning.setAttribute("data-visible", "data-visible");
                return;
            }
            //
            course.toggleAttribute("data-selected");
            renderProgrammeBuilderPricing();
        });
    };
    //------------------------------------------------------------------------------
    //add an event to each course to manage the user's selection
    for(var _iterator1 = programmeBuilderCourses[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_loop();
     //------------------------------------------------------------------------------
} catch (err) {
    _didIteratorError1 = true;
    _iteratorError1 = err;
} finally{
    try {
        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
            _iterator1.return();
        }
    } finally{
        if (_didIteratorError1) {
            throw _iteratorError1;
        }
    }
}

});
parcelRegister("dVE5d", function(module, exports) {
/**
 * Simple micro template system, based off John Resig's original function and other user contributions
 *
 * @package Mercury
 * @copyright 2021 National Residential Landlords Association
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */ //==============================================================================
//

var $haqKc = parcelRequire("haqKc");
module.exports = function(template, data) {
    var template_name = "zeno-template-cache-" + template;
    if (typeof window[template_name] == "undefined") window[template_name] = $a23fb0ec03d1c4b9$var$zeno_prepare_template(document.getElementById(template).innerHTML);
    return window[template_name](data || {});
};
//==============================================================================
//store all the callbacks that we want to use as filters
window.zeno_filter_callbacks = {}; //!!!
//add a function to allow adding of new filters
function $a23fb0ec03d1c4b9$var$zeno_template_add_filter(name, callback) {
    if (typeof callback === "function") zeno_filter_callbacks[name] = callback;
}
//==============================================================================
//declare some basic filters
$a23fb0ec03d1c4b9$var$zeno_template_add_filter("upper", function(value) {
    return value !== null ? value.toUpperCase() : "";
});
$a23fb0ec03d1c4b9$var$zeno_template_add_filter("lower", function(value) {
    return value !== null ? value.toLowerCase() : "";
});
$a23fb0ec03d1c4b9$var$zeno_template_add_filter("title", function(value) {
    return value !== null ? value.toTitleCase() : "";
});
//twig like replace filter
$a23fb0ec03d1c4b9$var$zeno_template_add_filter("replace", function(haystack, replacements) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(replacements)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $haqKc._)(_step.value, 2), needle = _step_value[0], value = _step_value[1];
            haystack = haystack.replace(needle, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return haystack;
});
$a23fb0ec03d1c4b9$var$zeno_template_add_filter("default", function(value, ifnull) {
    return value == "" ? ifnull : value;
});
$a23fb0ec03d1c4b9$var$zeno_template_add_filter("number_format", function(value, precision, zero_value) {
    if (value === null || isNaN(value) || value == 0) return typeof zero_value !== "undefined" ? zero_value : null;
    return parseInt(value, 10).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (parseInt(precision, 10) > 0 ? value.toFixed(precision).slice(-(precision + 1)) || "." + "0".repeat(precision) : "");
});
//==============================================================================
/**
 * Simple micro template system, based off John Resig's original function and other user contributions
 * @param  {string} template Required - The id of the template to render
 * @param  {object} data     Optional - The data to pass into the template renderer
 * @return {string}
 */ function $a23fb0ec03d1c4b9$var$zeno_prepare_template(template) {
    //remove any whitespace characters inside our [[ and ]] operators
    template = template.replace(/\[\[(\s+)/g, "[[");
    template = template.replace(/(\s+)\]\]/g, "]]");
    //allow the user to set variables for use later in the template
    template = template.replace(/\[\[set (.+)\]\]/g, "[[var $1;]]");
    //pre-parse some common commands into "native" template language
    template = template.replace(/\[\[if([^{]+?)\]\]/g, "[[ if ($1) { ]]"); // "[^{]" vs "." to prevent it from parsing the legacy if conditions
    template = template.replace(/\[\[else\]\]/g, "[[ } else { ]]");
    template = template.replace(/\[\[endif\]\]/g, "[[ } ]]");
    //for loops
    template = template.replace(/\[\[for ([^\(]+?) in (.+?)\]\]/g, "[[ if (typeof $2 !== 'undefined') { for (var _$1 in $2 ) { if ($2.hasOwnProperty(_$1)) { var $1 = $2[_$1], loop = {'index':_$1}; ]]");
    template = template.replace(/\[\[endfor\]\]/g, "[[ }}} ]]");
    //ternary if statements
    template = template.replace(/\[\[iif\((.+?),(.+?),(.+?)\)\]\]/g, "[[p.push((($1) ? $2 : $3));]]");
    template = template.replace(/\[\[iif\((.+?),(.+?)\)\]\]/g, "[[p.push((($1) ? $2 : ''));]]");
    //allow templates to be included from within other templates
    template = template.replace(/\[\[include(.+)with(.+)\]\]/g, "[[p.push(zeno_template($1, $.extend({}, data, $2)));]]");
    template = template.replace(/\[\[include(.+)\]\]/g, "[[p.push(zeno_template($1, data));]]");
    //condense any whitespace into a single space character
    template = template.replace(/[\r\t\n]/g, " ");
    //process any "echo" expressions
    template = template.replace(/\[\[=(.+?)\]\]/g, function(match, variable) {
        //process the string if it contains filters - currently only allowing 1 filter
        if ((filter = variable.match(/(.+?)\|(.+?)\((.+?)?\)/)) !== null && typeof zeno_filter_callbacks[filter[2]] == "function") return "',((typeof " + filter[1] + " !== 'undefined') ? zeno_filter_callbacks['" + filter[2] + "'](" + filter[1] + (filter[3] != undefined ? ", " + filter[3] : "") + ") : ''),'";
        //just a standard expression
        return "',((typeof " + variable + " !== 'undefined') ? " + variable + " : ''),'";
    });
    //
    template = template.replace(/\[\[/g, "');");
    template = template.replace(/\]\]/g, "p.push('");
    try {
        var template_callback = new Function("data", "var p = [], print = function() { p.push.apply(p, arguments); }; with(data) { p.push('" + template + "'); } return p.join('');");
        return template_callback;
    } catch (exception) {
        console.error(exception);
        console.error(template);
    }
    return "";
} //==============================================================================

});
parcelRegister("haqKc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c7f81dae783d026c$export$fdf2a89c76341bbf; });

var $kAoWz = parcelRequire("kAoWz");

var $51zgv = parcelRequire("51zgv");

var $8w5yq = parcelRequire("8w5yq");

var $8YVFh = parcelRequire("8YVFh");
function $c7f81dae783d026c$export$fdf2a89c76341bbf(arr, i) {
    return (0, $kAoWz._array_with_holes)(arr) || (0, $51zgv._iterable_to_array_limit)(arr, i) || (0, $8YVFh._unsupported_iterable_to_array)(arr, i) || (0, $8w5yq._non_iterable_rest)();
}

});
parcelRegister("kAoWz", function(module, exports) {

$parcel$export(module.exports, "_array_with_holes", function () { return $efca84b713134a66$export$e6256bf45c68d561; });
function $efca84b713134a66$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("51zgv", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array_limit", function () { return $3a8866aa092b1ebb$export$2fd15edff6687200; });
function $3a8866aa092b1ebb$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("8w5yq", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_rest", function () { return $63359ed8917f3ec8$export$60dbc22abd7da546; });
function $63359ed8917f3ec8$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("8YVFh", function(module, exports) {

$parcel$export(module.exports, "_unsupported_iterable_to_array", function () { return $68a0a85bb5bfa568$export$a5be06335b3a083c; });

var $822BU = parcelRequire("822BU");
function $68a0a85bb5bfa568$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $822BU._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $822BU._array_like_to_array)(o, minLen);
}

});
parcelRegister("822BU", function(module, exports) {

$parcel$export(module.exports, "_array_like_to_array", function () { return $5d9088fdefde415d$export$79e617b1955a2616; });
function $5d9088fdefde415d$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});




parcelRegister("kbC9w", function(module, exports) {

$parcel$export(module.exports, "get", function () { return $eb226e0a688f5e68$export$3988ae62b71be9a3; }, function (v) { return $eb226e0a688f5e68$export$3988ae62b71be9a3 = v; });
$parcel$export(module.exports, "set", function () { return $eb226e0a688f5e68$export$adaa4cf7ef1b65be; }, function (v) { return $eb226e0a688f5e68$export$adaa4cf7ef1b65be = v; });
/**
 * Get a value from the current page's session storage
 * @param  {[type]} key          [description]
 * @param  {[type]} defaultValue [description]
 * @return {[type]}              [description]
 */ var $eb226e0a688f5e68$export$3988ae62b71be9a3;
/**
 * Set a value from the current page's session storage
 * @param  {[type]} key   [description]
 * @param  {[type]} value [description]
 * @return {[type]}       [description]
 */ var $eb226e0a688f5e68$export$adaa4cf7ef1b65be;
/**
 * Remove a value from the current page's session storage
 * @param  {[type]} key [description]
 * @return {[type]}     [description]
 */ var $eb226e0a688f5e68$export$cd7f480d6b8286c3;
$eb226e0a688f5e68$export$3988ae62b71be9a3 = function(key) {
    var defaultValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    //
    var value = window.sessionStorage.getItem(key);
    //
    if (!value || value === "null") return null;
    //
    try {
        return JSON.parse(value);
    } catch (e) {
        console.log(e);
    }
    //
    return defaultValue;
};
$eb226e0a688f5e68$export$adaa4cf7ef1b65be = function(key) {
    var value = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    //
    if (value === undefined) value = null;
    else value = JSON.stringify(value);
    //
    try {
        window.sessionStorage.setItem(key, value);
    } catch (e) {
        console.log(e);
    }
};
$eb226e0a688f5e68$export$cd7f480d6b8286c3 = function(key) {
    window.localStorage.removeItem(key);
};

});



parcelRequire("97vXv");
})();
//# sourceMappingURL=training-programme-builder.min.js.map
